module.exports = __webpack_public_path__ + "static/media/Shetty.2543480f.png";